<template>
    <div id="tst">
      <v-tooltip style="z-index: 929;" bottom>
        <v-btn slot="activator" dark icon small flat @click.native="reenviar()">
          <v-icon>compare_arrows</v-icon> 
        </v-btn>
          <span>Reenviar solicitação por E-mail</span>
      </v-tooltip>
    </div>

</template>
<script>
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import formUsuario from "@/domain/conta/usuario/FormUsuario.js";
export default {
  props: ["conta", "empresa", "alert", "nota", "table", "cert"],
  components: {formUsuario},

  updated: function() {},
  data(){
    return{
       usuario: {
         colaborador: JSON.parse(JSON.stringify(this.nota)),
         empresas: [this.empresa._id]
       },
       reenvio: true
    }
  },
  watch: {},
  computed: {},
  methods: {
    reenviar(){
       this.service = new UsuarioService(this.$http);
       this.service.cadastrar( this.usuario, this.conta.conta, this.reenvio).then( res=>{this.$emit("attTableEmp", res);})
    },
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/reenvioEmail/ReenvioEmail.vue